import { render, staticRenderFns } from "./ChoixPhoto.vue?vue&type=template&id=53bc9584&scoped=true&"
import script from "./ChoixPhoto.vue?vue&type=script&lang=js&"
export * from "./ChoixPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ChoixPhoto.vue?vue&type=style&index=0&id=53bc9584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc9584",
  null
  
)

export default component.exports